// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "style/" + chunkId + "." + {"456":"f3af2aba9872cbc5dd83","961":"cf11786ba479026793e6"}[chunkId] + ".css";
};